// removed by extract-text-webpack-plugin
module.exports = {"featured_item":"slider__featured_item__1c6Zg","featured_image":"slider__featured_image__1Bj39","featured_caption":"slider__featured_caption__oYtDY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/NewsSlider/slider.css
// module id = 824
// module chunks = 0